import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgs/logos_move.png'


const _hoisted_1 = { id: "move-app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img",
  alt: ""
}, null, -1)

import { ref } from "vue";
import type { FormInstance } from "vant";
import { Toast } from "vant";
import Title from "../../../components/checkstand/Title.vue";
import Payment from "../../../components/checkstand/Payment.vue";
import BasicInfo from "./BasicInfo.vue";
import BillingAddress from "./BillingAddress.vue";
import CustomButton from "../../../components/checkstand/CustomButton.vue";
import OrderInfo from "../../../components/checkstand/OrderInfo.vue";
import { getOrder } from "../../../tools/checkstand/checkstandOrder";

interface ChildApi {
  form: FormInstance;
}

interface ErrorMsg {
  message: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { order, payment, submit } = getOrder();
const addressVisible = ref(false);

function openAddress(isOpen: boolean) {
  addressVisible.value = isOpen;
}

const basic = ref<ChildApi>();
const address = ref<ChildApi>();

function success() {
  submit();
}

function failed(errs: ErrorMsg[]) {
  const err = errs[0];
  Toast(`
    Data Verification Failed!
    err: ${err.name}
    msg: ${err.message}
  `);
}

function submitForm() {
  if (!addressVisible.value) {
    basic.value?.form.validate().then(success).catch(failed);
  } else {
    Promise.all([basic.value?.form.validate(), address.value?.form.validate()])
      .then(success)
      .catch(failed);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Payment, {
      paymentAmount: _unref(payment),
      class: "pay"
    }, null, 8, ["paymentAmount"]),
    _createVNode(Title, {
      text: "Basic Information",
      class: "title"
    }),
    _createVNode(BasicInfo, {
      class: "basic",
      ref_key: "basic",
      ref: basic
    }, null, 512),
    _createVNode(Title, {
      text: "The billing address is the same as the receiving address.",
      class: "title",
      open: "",
      onChangeSwitch: openAddress
    }),
    _withDirectives(_createVNode(BillingAddress, {
      class: "address",
      ref_key: "address",
      ref: address
    }, null, 512), [
      [_vShow, addressVisible.value]
    ]),
    _createVNode(CustomButton, {
      class: "button",
      onClickSubmit: submitForm
    }),
    _createVNode(OrderInfo, {
      "order-no": _unref(order).BillNo
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["order-no"])
  ]))
}
}

})